import React from 'react';
import styles from './Loder.module.css';

export default class Loader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    if (this.props.display === true) {
      return <div className={styles.loader} id="loading" />;
    } else {
      return null;
    }
  }
}
